<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center align-center">
        <v-flex xs12>
          <v-card class="elevation-22 rounded-5">
            <div class="pt-5 text-center">
              <h3 class="my-0 text-uppercase font-weight-lighter">Login</h3>
            </div>
            <v-card-text>
              <b-form method="POST" action="/login" ref="login-form" @submit.prevent="login(user)">
                <p class="red--text" v-if="errors.email">{{ errors.email }}</p>
                <v-text-field label="Username / Email" v-model="user.email" name="email" required="required"></v-text-field>
                <v-text-field label="Password" v-model="user.password" name="password" :type="pt ? 'text' : 'password'" required="required">
                  <v-icon slot="append" @click="pt = !pt">
                    {{ pt ? 'mdi-eye-off' : 'mdi-eye' }}
                  </v-icon>
                </v-text-field>
                <v-checkbox v-model="user.remember" label="Remember Me" color="primary" name="remember"></v-checkbox>
                <v-btn type="submit" small class="primary pull-right" :loading="processing">Login</v-btn>
                <v-btn small icon color="red" fab outlined @click="webauthlogin" v-if="!isAndroid">
                  <v-icon>mdi-fingerprint</v-icon>
                </v-btn>
              </b-form>
            </v-card-text>
            <v-card-actions>
              <v-btn small text href="/forgot-password" @click.stop.prevent="goTo('/forgot-password')">Forgot Password?</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import { useLogin } from '@web-auth/webauthn-helper'

  export default {
    name: 'Login',
    props: [
      'errors'
    ],
    metaInfo () {
      return {
        title: 'Login',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        user: {
          email: '',
          password: '',
        },
        pt: false,
        processing: false,
      }
    },
    methods: {
      somemethod () {},
      login (user) {
        this.processing = true
        this.$inertia.post('/login', this.user, {
          onFinish: () => {
            this.processing = false
          }
        })
      },
      turnofftext () {
        if (this.pt) {
          var vm = this
          setTimeout(function () {
            vm.pt = false
          }, 1500)
        }
      },
      webauthlogin () {
        new Larapass({
            login: '/webauthn/login',
            loginOptions: '/webauthn/login/options'
        }).login({
            // email: this.user.email
        }, {
            'WebAuthn-Remember': this.user.remember
        }).then(response => {
          swal({ title: 'Authentication successful!', type: 'success', timer: 2500 })
          this.$inertia.reload();
        })
          .catch(error => {
            alert('Something went wrong, try again!')
            swal({
              title: '',
              text: 'Have you registered this device? <br> Login with your password, go to your profile page and register this device to use it to login in the future.',
              type: 'error',
              showCancelButton: true,
              confirmButtonColor: 'red',
              confirmButtonText:'Ok',
              closeOnConfirm: true,
              showLoaderOnConfirm: false,
            })
          })
      }
    },
    computed: {
      isAndroid () {
        let agent = navigator.userAgent.toLowerCase()
        let index = agent.indexOf('android')
        return index > -1
      }
    },
    watch: {
      'pt': 'turnofftext'
    },
    mounted () {
      this.$nextTick(() => {
        // let _token = document.querySelector("meta[name='csrf-token']").getAttribute('content')
        var request = new Event('loginrequest')
        window.dispatchEvent(request)
      })
    }
  }
</script>

<style>
  .fh {
    height: calc(100vh - 100px);
  }
</style>
